
import {groupSkills} from './commands-menu-defs'

export default {
  props: {
    disabled: {type: Boolean, default: false},
    skills: {type: Array, required: true},
    sources: {type: Array, required: true},
  },
  emits: ['source', 'skill'],
  data() {
    return {visible: false}
  },
  computed: {
    skill_groups() {
      return groupSkills(this.skills)
    }
  },
  methods: {
    selectSkill(command) {
      this.close()
      this.$emit('skill', command)
    },
    selectSource(command) {
      this.close()
      this.$emit('source', command)
    },
    close() {
      this.$refs.dropdown.handleClose()
    }
  }
}
